import {Injectable} from '@angular/core';
import {AzureAppConfigurationService} from './azure-app-configuration.service';
import {FeatureFlagValue, GetConfigurationSettingResponse} from '@azure/app-configuration';
import {catchError} from 'rxjs/operators';
import {map, Observable, of} from 'rxjs';
import {AppInsightsService} from './app-insights.service';

@Injectable({
  providedIn: 'root'
})
export class FeatureService {
  constructor(
    private azureAppConfigurationService: AzureAppConfigurationService,
    private appInsightsService: AppInsightsService) {
  }

  public isEnabledFeature(featureName: string): Observable<boolean> {
    return this.azureAppConfigurationService
      .getConfigurationSetting(featureName)
      .pipe(
        map((response: GetConfigurationSettingResponse | undefined) => {
          return response?.value
            ? (JSON.parse(response.value) as FeatureFlagValue).enabled
            : false;
        }),
        catchError((error: Error) => {
          this.appInsightsService.logException(error);
          return of(false);
        })
      );
  }
}
